/** On-site — the check-in status (changed through the check-in actions queued in the
 *  draft) and the check-in notes the guide sees; ticket redemption as the reservation
 *  system reports it; the check-in source, time, error, link, window and whether the
 *  guide's list shows the booking as System. */
import type { BookingRecordStage } from '@/api/bookingRecord';
import type { ViewSection } from '@/features/records/views/types';

import type { BookingDisplayContext } from './displays';
import { PanelMeta } from './PanelMeta';
import { StagePanel } from './StagePanel';

export function OnsitePanel({
  section,
  display,
}: {
  section: ViewSection<BookingRecordStage>;
  display: BookingDisplayContext;
}) {
  return <StagePanel section={section} display={display} meta={<PanelMeta>Times in {display.tz}</PanelMeta>} />;
}
